import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import TwitchLive from "@/components/TwitchLive";
import Showcase from "@/components/Showcase";
import MagicSection from "@/components/MagicSection";
import MusicSection from "@/components/MusicSection";
import YoutubeVideos from "@/components/YoutubeVideos";
import BlogPreview from "@/components/BlogPreview";
import Manifesto from "@/components/Manifesto";
import SocialSection from "@/components/SocialSection";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Home() {
  const { lang } = useLanguage();
  return (
    <div className="grain min-h-screen bg-void text-white">
      <Seo
        title={lang === "it" ? "Fabio Comelli — Sviluppatore di app iOS" : "Fabio Comelli — iOS App Developer"}
        path="/"
        description={lang === "it"
          ? "Sito ufficiale di Fabio Comelli, sviluppatore di app per iOS: Parole in Coda, Cthulhu Tracker e Simple and Fast. Giochi di parole e compagni per il gioco di ruolo."
          : "Official site of Fabio Comelli, iOS app developer: Parole in Coda, Cthulhu Tracker and Simple and Fast. Word games and tabletop RPG companions."}
      />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <TwitchLive />
        <Showcase />
        <MagicSection />
        <MusicSection />
        <YoutubeVideos />
        <BlogPreview />
        <Manifesto />
        <SocialSection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
